import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { ProcessStatus, ProcessStatusGroup } from '__generated__/graphql'
import { FC } from 'react'
import { useProcessStatusColorMap } from './colorHelperFunction'
import { useProcessStatuses } from 'shared/hooks/useProcessStatuses'

interface Props {
    status?: ProcessStatus
    statusLabel?: string
    summaryGroup?: ProcessStatusGroup
    summaryGroupLabel?: string
    title?: string
    sx?: React.CSSProperties
    processStatusId?: string
}

const ProcessStatusPill: FC<Props> = ({
    status,
    statusLabel,
    summaryGroup,
    title,
    sx,
    processStatusId,
}) => {
    const theme = useTheme()
    const { processStatusMap } = useProcessStatuses()

    const processStatusData = processStatusId
        ? processStatusMap.get(processStatusId)
        : null

    const displayStatus = processStatusData?.status || status
    const displayStatusLabel = processStatusData?.statusLabel || statusLabel
    const displaySummaryGroup =
        processStatusData?.processStatusSummaryGroup?.summaryGroup ||
        summaryGroup

    const displayTitle =
        processStatusData?.statusLabel || title || 'Process Status'

    const backgroundColor = useProcessStatusColorMap(displaySummaryGroup)

    return (
        <Chip
            title={displayTitle}
            size="small"
            label={displayStatusLabel || displayStatus || 'N/A'}
            sx={{
                backgroundColor,
                color: theme.palette.greyscale.white,
                ...sx,
            }}
        />
    )
}

export default ProcessStatusPill
